{
  "ATTRIBUTES_MGMT": {
    "HEADER": "แอตทริบิวต์ที่กำหนดเอง",
    "HEADER_BTN_TXT": "เพิ่มแอตทริบิวต์เเบบกำหนดเอง",
    "LOADING": "กำลังดึงแอตทริบิวต์ที่กำหนดเอง",
    "DESCRIPTION": "A custom attribute tracks additional details about your contacts or conversations—such as the subscription plan or the date of their first purchase. You can add different types of custom attributes, such as text, lists, or numbers, to capture the specific information you need.",
    "LEARN_MORE": "Learn more about custom attributes",
    "COUNT": "{n} attribute | {n} attributes",
    "SEARCH_PLACEHOLDER": "Search attributes...",
    "NO_RESULTS": "No attributes found matching your search",
    "ATTRIBUTE_MODELS": {
      "CONVERSATION": "การสนทนา",
      "CONTACT": "ผู้ติดต่อ",
      "COMPANY": "บริษัท"
    },
    "ATTRIBUTE_TYPES": {
      "TEXT": "ข้อความ",
      "NUMBER": "ตัวเลข",
      "LINK": "ลิงก์",
      "DATE": "Date",
      "LIST": "รายการ",
      "CHECKBOX": "ช่องทำเครื่องหมาย"
    },
    "ADD": {
      "TITLE": "เพิ่มแอตทริบิวต์เเบบกำหนดเอง",
      "SUBMIT": "สร้าง",
      "CANCEL_BUTTON_TEXT": "ยกเลิก",
      "FORM": {
        "NAME": {
          "LABEL": "ชื่อแอตทริบิวต์",
          "PLACEHOLDER": "โปรดใส่ชื่อของแอตทริบิวต์",
          "ERROR": "โปรดระบุชื่อ"
        },
        "DESC": {
          "LABEL": "คำอธิบาย",
          "PLACEHOLDER": "โปรดใส่รายละเอียดของแอตทริบิวต์",
          "ERROR": "โปรดระบุคำอธิบาย"
        },
        "MODEL": {
          "LABEL": "นำไปใช้กับ",
          "PLACEHOLDER": "กรุณาเลือกประเภท",
          "ERROR": "ต้องการ Model"
        },
        "TYPE": {
          "LABEL": "ประเภท",
          "PLACEHOLDER": "กรุณาเลือกประเภท",
          "ERROR": "โปรดระบุประเภท",
          "LIST": {
            "LABEL": "รายการ",
            "PLACEHOLDER": "โปรดระบุ Value และ Key",
            "ERROR": "โปรดระบุ Value"
          }
        },
        "KEY": {
          "LABEL": "คีย์",
          "PLACEHOLDER": "โปรดใส่คีย์ของแอตทริบิวต์เเบบกำหนดเอง",
          "ERROR": "โปรดระบุคีย์",
          "IN_VALID": "คีย์นี้ใช้ไม่ได้"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex Pattern",
          "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex Cue",
          "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Enable regex validation"
        },
        "BADGES": {
          "PRE_CHAT": "Pre-chat",
          "RESOLUTION": "Resolution"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "เพิ่มแอตทริบิวต์เเบบกำหนดเองสำเร็จแล้ว!",
        "ERROR_MESSAGE": "Could not create a Custom Attribute. Please try again later."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "ลบ",
      "API": {
        "SUCCESS_MESSAGE": "ลบแอตทริบิวต์เเบบกำหนดเองสำเร็จแล้ว",
        "ERROR_MESSAGE": "ไม่สามารถลบแอตทริบิวต์เเบบกำหนดเอง โปรดลองอีกครั้ง"
      },
      "CONFIRM": {
        "TITLE": "คุณแน่ใจว่าต้องการลบ {attributeName} หรือไม่",
        "PLACE_HOLDER": "โปรดใส่ {attributeName} เพื่อยืนยัน",
        "MESSAGE": "การลบจะทำให้แอตทริบิวต์เเบบกำหนดเองจะหายไป",
        "YES": "ลบ ",
        "NO": "ยกเลิก"
      }
    },
    "EDIT": {
      "TITLE": "แก้ไขแอตทริบิวต์เเบบกำหนดเอง",
      "UPDATE_BUTTON_TEXT": "อัพเดท",
      "TYPE": {
        "LIST": {
          "LABEL": "รายการ",
          "PLACEHOLDER": "โปรดใส่ค่าและกด Enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "อัปเดตแอตทริบิวต์เเบบกำหนดเองสำเร็จแล้ว",
        "ERROR_MESSAGE": "เกิดข้อผิดพลาดระหว่างอัปเดตแอตทริบิวต์เเบบกำหนดเอง โปรดลองอีกครั้ง"
      }
    },
    "TABS": {
      "HEADER": "แอตทริบิวต์ที่กำหนดเอง",
      "CONVERSATION": "การสนทนา",
      "CONTACT": "รายชื่อผู้ติดต่อ",
      "COMPANY": "บริษัท"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "ชื่อ",
        "DESCRIPTION": "คำอธิบาย",
        "TYPE": "ประเภท",
        "KEY": "คีย์"
      },
      "BUTTONS": {
        "EDIT": "เเก้ไข",
        "DELETE": "ลบ"
      },
      "EMPTY_RESULT": {
        "404": "ไม่พบแอตทริบิวต์เเบบกำหนดเองที่สร้างไว้",
        "NOT_FOUND": "ไม่มีแอตทริบิวต์เเบบกำหนดเอง ที่กำหนดค่าไว้"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex Pattern",
        "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex Cue",
        "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Enable regex validation"
      }
    },
    "BADGES": {
      "PRE_CHAT": "Pre-chat",
      "RESOLUTION": "Resolution"
    }
  }
}
